















































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import moment from "moment";
import Timer = NodeJS.Timer;
import {PlayerConfig} from "@/interfaces/player.interface";
import {bus} from "@/plugins/bus";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";
import Keyword from "@/components/Keyword.vue";
import {PlayerType} from "@/interfaces/film.interface";

@Component({
  components: {
    Keyword
  }
})

export default class Player extends Vue {
  @Prop() hideInfo: boolean;
  @Prop() playerSize: number;
  @Prop() hideControls: boolean;
  @Prop() isCalculateWidth: boolean;
  @Prop() openFullscreenOnStart: boolean;
  @Prop() ignorePageMargin: number;
  @Prop() selectedKeyword: any;
  @Prop() openFullscreenOnPlay: boolean;
  @Prop() videoUrl: string;
  @Prop() onVideoLoaded: Function;
  @Prop() forcedRatio: number;
  @Prop() videoInfo: PlayerConfig.IVideoInfo;
  @Prop() isSynchronous: boolean;
  @Prop() videoDetail: boolean;
  @Prop({ default: PlayerType.Vimeo }) playerType: string;
  @Prop() playerName!: string;

  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  playerTypes = PlayerType;
  videoPlay: boolean = false;
  showOnPlayControl: boolean = false;
  showOnPlayControlFullScreen: boolean = false;
  videoTime: number = 0;
  showInfo: boolean = false;
  isMute: boolean = false;
  volumeValue: number = 25;
  mobile: boolean;
  countClick: number = 0;

  fullScreen: boolean = false;

  videoDuration: string = '';
  videoDurationSec: number = 0;

  controlTimer: Timer;

  basicVideoWidth: number = 75;
  videoWidth: number = 100;
  videoMargin: number = 0;

  width: number = 0;
  height: number = 0;
  ratio: number = 1.777777;

  playerWidth: number = 0;

  isMouseAction: boolean = true;

  fullscreenPrefixes = [
    { open: 'requestFullscreen', close: 'exitFullscreen' },
    { open: 'webkitRequestFullscreen', close: 'webkitExitFullscreen' },
    { open: 'webkitRequestFullScreen', close: 'webkitExitFullscreen' },
    { open: 'mozRequestFullScreen', close: 'mozCancelFullScreen' },
  ];

  mediaQueryTablet: MediaQueryList;
  mediaQuerySmallTablet: MediaQueryList;
  mediaQueryMobile: MediaQueryList;
  isScrolledDetailsPage = false;

  fullscreenEventTimeout = false;
  playerWasActivate = false;
  acceptVimeoCookies = false;

  created() {
    this.mobile = !!(this.$device.mobile || this.$device.ios);
    this.acceptVimeoCookies = JSON.parse(localStorage.getItem('acceptVimeoCookies'));
    bus.$on(EventEmitter.Events.DETAIL_SCROLLED, (isScrolled) => {
      this.showInfo = false;
      this.isScrolledDetailsPage = isScrolled;
    });

    bus.$on('UpdateCookieBotState', () => {
      this.acceptVimeoCookies = JSON.parse(localStorage.getItem('acceptVimeoCookies'));
    });
  }

  mounted() {
    (this.$refs.area as any).addEventListener('fullscreenchange', this.onFullscreenChange, false);
    (this.$refs.area as any).addEventListener('mozfullscreenchange', this.onFullscreenChange, false);
    (this.$refs.area as any).addEventListener('webkitfullscreenchange', this.onFullscreenChange, false);
    (this.$refs.area as any).addEventListener('msfullscreenchange', this.onFullscreenChange, false);

    this.mediaQueryTablet = window.matchMedia("(max-width: 992px)");
    this.mediaQuerySmallTablet = window.matchMedia("(max-width: 768px)");
    this.mediaQueryMobile = window.matchMedia("(max-width: 576px)");
    this.mediaQueryTablet.addListener(this.checkMedia);
    this.mediaQuerySmallTablet.addListener(this.checkMedia);
    this.mediaQueryMobile.addListener(this.checkMedia);
    window.addEventListener("resize", this.onPlayerResize);

    this.checkMedia();

    bus.$on(EventEmitter.Events.PLAYER_STICKY_CHANGE, () => {
      setTimeout( () => {
        if (this.$refs.tags) {
          this.playerWidth = (this.$refs.tags as HTMLElement).offsetWidth;
        }
      }, 200)
    });

    let interval = setInterval(() => {
      if (this.$refs.player && this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) {
        (this.$refs.player as any).player.setAutopause(false);
        (this.$refs.player as any).player.on('bufferend', async () => {
          let time = await (this.$refs.player as any).player.getCurrentTime();
          this.$emit('actionCallSynchronous', { action: 'buffering', payload: time, name: this.playerName });
        });
        clearInterval(interval);
      }
    }, 100);
  }

  async onLinkClick(url) {
    await this.$store.dispatch('routerStore/openPage', {
      url: url.replace('internal:', ''),
      external: true
    });
  }

  onPlayerResize() {
    if (this.$refs.tags) {
      this.playerWidth = (this.$refs.tags as HTMLElement).offsetWidth;
    }
  }

  checkMedia() {
    this.videoWidth = 100;

    if (this.mediaQueryMobile.matches) {
      this.videoMargin = (this.ignorePageMargin >= PlayerConfig.IgnorePageMarginBreakpoints.MOBILE) ? 30 : 0;
    }
    else if (this.mediaQuerySmallTablet.matches) {
      this.videoMargin = (this.ignorePageMargin >= PlayerConfig.IgnorePageMarginBreakpoints.SMALL_TABLET) ? 90 : 0;
    }
    else if (this.mediaQueryTablet.matches) {
      this.videoMargin = (this.ignorePageMargin >= PlayerConfig.IgnorePageMarginBreakpoints.TABLET) ? 130 : 0;
    }
    else {
      this.videoMargin = 0;
      this.videoWidth = (this.isCalculateWidth) ? this.basicVideoWidth : 100;
    }
  }

  calculateWidth() {
    if (this.width && this.height) {
      this.basicVideoWidth = 75;
      this.ratio = this.forcedRatio || this.width / this.height;
      if (this.onVideoLoaded) {
        this.onVideoLoaded(this.ratio);
      }
      const width = this.basicVideoWidth + (this.ratio - (4/3))/0.040404;
      this.basicVideoWidth = (width > 100 || !this.isCalculateWidth) ? 100 : width;
      setTimeout( () => {
        this.checkMedia();
        bus.$emit(EventEmitter.Events.PLAYER_READY);
      })
    }
  }

  onEnded() {
    this.videoPlay = false;
    this.onPlayControlShow();
  }

  onFullscreenChange() {
    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
      /* iOS hides Safari address bar */
      window.addEventListener("load",() => {
        setTimeout(() => {
          window.scrollTo(0, 1);
        }, 1000);
      });
    }
    if (!this.fullscreenEventTimeout) {
      this.fullscreenEventTimeout = true;
      this.showInfo = false;
      this.fullScreen = !this.fullScreen;
      if (this.$device.ios || this.$device.ipad) {
        bus.$emit(EventEmitter.Events.IOS_FULLSCREEN_CHANGE, this.fullScreen);
      }
      if (!this.fullScreen) {
        bus.$emit(EventEmitter.Events.EXIT_FULLSCREEN);
      }
      setTimeout( () => {this.fullscreenEventTimeout = false});
    }
  }

  onPlayerReady(event, player) {
    if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) {
      player.getVideoWidth().then(
        (value) => {
          this.width = value;
          this.calculateWidth();
          setTimeout(() => this.onPlayerResize(), 200);
        }
      );

      player.getVideoHeight().then(
        (value) => {
          this.height = value;
          this.calculateWidth();
        }
      );

      player.getDuration().then(
        (value) => {
          this.videoDurationSec = value;
          const time = moment.duration(value, 'seconds');
          const hours = time.hours();
          const minutes = (time.minutes() < 10) ? `0${time.minutes()}` : time.minutes();
          const seconds = (time.seconds() < 10) ? `0${time.seconds()}` : time.seconds();
          this.videoDuration = `${hours}:${minutes}:${seconds}`;
        }
      );
    }
    if (this.playerType === this.playerTypes.Html) {
      this.calculateWidth();
      setTimeout(() => this.onPlayerResize(), 200);
      this.videoDurationSec = (this.$refs.player as any).duration;
      const time = moment.duration((this.$refs.player as any).duration, 'seconds');
      const hours = time.hours();
      const minutes = (time.minutes() < 10) ? `0${time.minutes()}` : time.minutes();
      const seconds = (time.seconds() < 10) ? `0${time.seconds()}` : time.seconds();
      this.videoDuration = `${hours}:${minutes}:${seconds}`;
    }
  }

  onTimeChange(event) {
    if (this.isSynchronous && (!this.countClick || this.countClick === 1)) {
      this.countClick++;
      if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) (this.$refs.player as any).player.setCurrentTime(this.videoInfo.video_start);
      if (this.playerType === this.playerTypes.Html) (this.$refs.player as any).currentTime = this.videoInfo.video_start;
    }
    else {
      if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) (this.$refs.player as any).player.setCurrentTime(event);
      if (this.playerType === this.playerTypes.Html) (this.$refs.player as any).currentTime = event;
    }
    (this.$refs.player as any).play();
    this.videoPlay = true;
  }

  onTimeInput(event) {
    if (!this.isMouseAction) {
      // (this.$refs.player as any).pause();
      if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) (this.$refs.player as any).player.setCurrentTime(event);
      if (this.playerType === this.playerTypes.Html) (this.$refs.player as any).currentTime = event;
      this.$emit('actionCallSynchronous', { action: 'time-change', payload: event, name: this.playerName });
    }
    this.isMouseAction = false;
  }

  onTimeupdate(event) {
    let eventSeconds = 0;
    if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) eventSeconds = event.seconds;
    if (this.playerType === this.playerTypes.Html) eventSeconds = (this.$refs.player as any).currentTime;

    const time = moment.duration(eventSeconds,'seconds');
    const hours = time.hours();
    const minutes = (time.minutes() < 10) ? `0${time.minutes()}` : time.minutes();
    const seconds = (time.seconds() < 10) ? `0${time.seconds()}` : time.seconds();
    this.videoDuration = `${hours}:${minutes}:${seconds}`;
    this.isMouseAction = true;
    this.videoTime = eventSeconds;
  }

  synchronousAction({ action, payload } : { action: string, payload?: any }) {
    switch (action) {
      case 'play':
        this.playVideoAction();
        break;

      case 'pause':
        this.pauseVideoAction();
        break;

      case 'time-change':
        this.onTimeChange(payload);
        break;
    }
  }

  onplayClick() {
    this.countClick++;
    if (this.videoDetail && !this.isScrolledDetailsPage && !this.fullScreen) {
      this.onFullscreenClick();
    }
    if (this.isSynchronous) this.$emit('actionCallSynchronous', { action: 'play', name: this.playerName });
    else this.playVideoAction();
  }

  playVideoAction() {
    if (!this.countClick || this.countClick === 1) {
      if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) (this.$refs.player as any).player.setCurrentTime(this.videoInfo.video_start);
      if (this.playerType === this.playerTypes.Html) (this.$refs.player as any).currentTime = this.videoInfo.video_start;
    }

    this.addSpaceButtonProcess();
    this.videoPlay = true;
    this.isMouseAction = true;
    (this.$refs.player as any).play();
  }

  addSpaceButtonProcess() {
    if (!this.playerWasActivate && this.videoDetail) {
      this.playerWasActivate = true;
      document.documentElement.addEventListener('keydown', this.spaceButtonListener, false);
    }
  }

  spaceButtonListener(e) {
    if ( ( e.keyCode || e.which ) == 32) {
      e.preventDefault();
      if (this.videoPlay) {
        this.onPauseClick();
      }
      else {
        this.onplayClick();
      }
    }
  }

  onPauseClick() {
    if (this.isSynchronous) this.$emit('actionCallSynchronous', { action: 'pause', name: this.playerName });
    else this.pauseVideoAction();
  }

  pauseVideoAction() {
    (this.$refs.player as any).pause();
    this.videoPlay = false;
    this.onPlayControlShow();
  }

  onFragmentButtonClick(value) {
    if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) (this.$refs.player as any).player.setCurrentTime(Math.min(value || 0, this.videoDurationSec));
    if (this.playerType === this.playerTypes.Html) (this.$refs.player as any).currentTime = Math.min(value || 0, this.videoDurationSec);
    (this.$refs.player as any).play();
    this.videoPlay = true;
  }

  onPlayControlShow() {
    this.showOnPlayControl = this.videoPlay;
    this.showOnPlayControlFullScreen = true;

    if (this.controlTimer) clearTimeout(this.controlTimer);
    this.controlTimer = setTimeout(() => {
      this.showOnPlayControl = false;
      this.showOnPlayControlFullScreen = false;
    }, 3000)
  }

  onPrevClick() {
    if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) (this.$refs.player as any).player.setCurrentTime( Math.max(0, this.videoTime - 15) );
    if (this.playerType === this.playerTypes.Html) (this.$refs.player as any).currentTime = Math.max(0, this.videoTime - 15);
  }

  onNextClick() {
    if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) (this.$refs.player as any).player.setCurrentTime( Math.min(this.videoTime + 15, this.videoDurationSec) );
    if (this.playerType === this.playerTypes.Html) (this.$refs.player as any).currentTime = Math.min(this.videoTime + 15, this.videoDurationSec);
  }

  onShowInfoClick() {
    this.showInfo = !this.showInfo;
  }

  onVolumeClick() {
    if (!!(this.isMute = !this.isMute)) {
      if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) (this.$refs.player as any).mute();
      if (this.playerType === this.playerTypes.Html) (this.$refs.player as any).volume = 0;
    }
    else {
      if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) (this.$refs.player as any).unmute(1);
      if (this.playerType === this.playerTypes.Html) (this.$refs.player as any).volume = this.volumeValue * 0.01;
      this.onVolumeValueChange();
    }
  }

  async onVolumeValueChange() {
    if (this.volumeValue) {
      if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) (this.$refs.player as any).unmute(1);
      if (this.playerType === this.playerTypes.Html) (this.$refs.player as any).volume = this.volumeValue * 0.01;
      this.isMute = false;
    }
    else {
      if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) (this.$refs.player as any).mute();
      if (this.playerType === this.playerTypes.Html) (this.$refs.player as any).volume = 0;
      this.isMute = true;
    }

    if (this.playerType === this.playerTypes.Vimeo && this.acceptVimeoCookies) (this.$refs.player as any).player.setVolume(this.volumeValue * 0.01);
    if (this.playerType === this.playerTypes.Html) (this.$refs.player as any).volume = this.volumeValue * 0.01;
  }

  changeDisplayElements(display: boolean) {
    let selectors = [
      'header',
      '.sticky-panel.sticky-panel--detail-page',
      '.history-link',
    ];
    selectors.forEach(selector => {
      let element = (document.querySelector(selector) as HTMLElement);
      if (element) element.style.visibility = display ? 'visible' : 'hidden';
    });
  }

  onFullscreenClick() {
    let isIos = true;
    this.fullscreenPrefixes.forEach(prefix => {
      if (!this.fullScreen) {
        if (this.$refs.area[prefix.open]) {
          this.changeDisplayElements(false);

          this.$refs.area[prefix.open]();
          isIos = false;
        }
      }
      else {
        if (document[prefix.close]) {
          document[prefix.close]();
          isIos = false;
          bus.$emit(EventEmitter.Events.EXIT_FULLSCREEN);
          this.changeDisplayElements(true);
        }
      }
    });
    if (isIos) {
      this.onFullscreenChange();
    }
  }

  openCookieBot() {
    (window as any).Cookiebot.show();
  }

  destroyed() {
    bus.$emit(EventEmitter.Events.IOS_FULLSCREEN_CHANGE, false);
    window.removeEventListener("resize", this.onPlayerResize);
    document.documentElement.removeEventListener('keydown', this.spaceButtonListener);
    bus.$off(EventEmitter.Events.DETAIL_SCROLLED);
    bus.$off('UpdateCookieBotState');
  }

  @Watch('isCalculateWidth')
  onIsCalculateWidthChange() {
    this.basicVideoWidth = 75;
    this.calculateWidth();
  }

  @Watch('videoWidth')
  onVideoWidthChange() {
    this.onPlayerResize();
  }

  @Watch('videoMargin')
  onVideoMarginChange() {
    this.onPlayerResize();
  }

  @Watch('playerSize')
  onPlayerSizeChange() {
    if (this.playerSize < 1) {
      this.showInfo = false;
    }
  }
}
